import { handleActions, combineActions } from 'redux-actions';

import { NAMES as SERVER_CHANNEL_REMOVE } from 'dashboard/redux/server/actions/channel/remove';
import { NAMES as SERVER_CHANNEL_UPDATE } from 'shared/redux/server/actions/channel/update';
import { NAMES as SERVER_CHANNELS_LIST } from 'shared/redux/server/actions/channels/list';
import { NAMES as SERVER_CHANNEL_GET } from 'shared/redux/server/actions/channel/get';
import { NAMES as SERVER_CHANNEL_PUBLISH } from 'shared/redux/server/actions/channel/publish';
import { NAMES as CLIENT_CHANNEL_UPDATE } from 'shared/redux/client/actions/channel/update';


const UPDATE_ACTIONS = [
  SERVER_CHANNEL_PUBLISH.START,
  SERVER_CHANNEL_UPDATE.SUCCESS,
  CLIENT_CHANNEL_UPDATE.SUCCESS,
];


export default handleActions({
  [combineActions(SERVER_CHANNELS_LIST.SUCCESS, SERVER_CHANNEL_GET.SUCCESS, ...UPDATE_ACTIONS)](state, { payload }) {
    const channels = _.get(payload, 'response.data.entities.channels');

    return _.merge({}, state, channels);
  },

  [SERVER_CHANNEL_REMOVE.SUCCESS]: (state, { payload }) => {
    const { id } = payload.params;

    return _.omit(state, id);
  },
}, {});



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/entities/channels.js